@if (config['showToolbar']) {
  <div class="ngx-toolbar">
    <div class="ngx-toolbar-set">
      @if (canEnableToolbarOptions('bold')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('bold')"
          title="Bold" [disabled]="!config['enableToolbar']">
          <i class="fa fa-bold" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('italic')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('italic')"
          title="Italic" [disabled]="!config['enableToolbar']">
          <i class="fa fa-italic" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('underline')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('underline')"
          title="Underline" [disabled]="!config['enableToolbar']">
          <i class="fa fa-underline" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('strikeThrough')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('strikeThrough')"
          title="Strikethrough" [disabled]="!config['enableToolbar']">
          <i class="fa fa-strikethrough" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('superscript')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('superscript')"
          title="Superscript" [disabled]="!config['enableToolbar']">
          <i class="fa fa-superscript" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('subscript')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('subscript')"
          title="Subscript" [disabled]="!config['enableToolbar']">
          <i class="fa fa-subscript" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="ngx-toolbar-set">
      @if (canEnableToolbarOptions('fontName')) {
        <button type="button" class="ngx-editor-button" (click)="fontName = ''" title="Font Family"
          [popover]="fontNameTemplate" #fontNamePopover="bs-popover" containerClass="ngxePopover" [disabled]="!config['enableToolbar']">
          <i class="fa fa-font" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('fontSize')) {
        <button type="button" class="ngx-editor-button" (click)="fontSize = ''" title="Font Size"
          [popover]="fontSizeTemplate" #fontSizePopover="bs-popover" containerClass="ngxePopover" [disabled]="!config['enableToolbar']">
          <i class="fa fa-text-height" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('color')) {
        <button type="button" class="ngx-editor-button" (click)="hexColor = ''" title="Color Picker"
          [popover]="insertColorTemplate" #colorPopover="bs-popover" containerClass="ngxePopover" [disabled]="!config['enableToolbar']">
          <i class="fa fa-tint" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="ngx-toolbar-set">
      @if (canEnableToolbarOptions('justifyLeft')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('justifyLeft')"
          title="Justify Left" [disabled]="!config['enableToolbar']">
          <i class="fa fa-align-left" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('justifyCenter')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('justifyCenter')"
          title="Justify Center" [disabled]="!config['enableToolbar']">
          <i class="fa fa-align-center" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('justifyRight')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('justifyRight')"
          title="Justify Right" [disabled]="!config['enableToolbar']">
          <i class="fa fa-align-right" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('justifyFull')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('justifyFull')"
          title="Justify" [disabled]="!config['enableToolbar']">
          <i class="fa fa-align-justify" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('indent')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('indent')"
          title="Indent" [disabled]="!config['enableToolbar']">
          <i class="fa fa-indent" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('outdent')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('outdent')"
          title="Outdent" [disabled]="!config['enableToolbar']">
          <i class="fa fa-outdent" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="ngx-toolbar-set">
      @if (canEnableToolbarOptions('cut')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('cut')" title="Cut"
          [disabled]="!config['enableToolbar']">
          <i class="fa fa-scissors" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('copy')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('copy')"
          title="Copy" [disabled]="!config['enableToolbar']">
          <i class="fa fa-files-o" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('delete')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('delete')"
          title="Delete" [disabled]="!config['enableToolbar']">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('removeFormat')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('removeFormat')"
          title="Clear Formatting" [disabled]="!config['enableToolbar']">
          <i class="fa fa-eraser" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('undo')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('undo')"
          title="Undo" [disabled]="!config['enableToolbar']">
          <i class="fa fa-undo" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('redo')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('redo')"
          title="Redo" [disabled]="!config['enableToolbar']">
          <i class="fa fa-repeat" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="ngx-toolbar-set">
      @if (canEnableToolbarOptions('paragraph')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('insertParagraph')"
          title="Paragraph" [disabled]="!config['enableToolbar']">
          <i class="fa fa-paragraph" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('blockquote')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('blockquote')"
          title="Blockquote" [disabled]="!config['enableToolbar']">
          <i class="fa fa-quote-left" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('removeBlockquote')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('removeBlockquote')"
          title="Remove Blockquote" [disabled]="!config['enableToolbar']">
          <i class="fa fa-quote-right" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('horizontalLine')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('insertHorizontalRule')"
          title="Horizontal Line" [disabled]="!config['enableToolbar']">
          <i class="fa fa-minus" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('unorderedList')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('insertUnorderedList')"
          title="Unordered List" [disabled]="!config['enableToolbar']">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('orderedList')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('insertOrderedList')"
          title="Ordered List" [disabled]="!config['enableToolbar']">
          <i class="fa fa-list-ol" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="ngx-toolbar-set">
      @if (canEnableToolbarOptions('link')) {
        <button type="button" class="ngx-editor-button" (click)="buildUrlForm()" [popover]="insertLinkTemplate"
          title="Insert Link" #urlPopover="bs-popover" containerClass="ngxePopover" [disabled]="!config['enableToolbar']">
          <i class="fa fa-link" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('unlink')) {
        <button type="button" class="ngx-editor-button" (click)="triggerCommand('unlink')"
          title="Unlink" [disabled]="!config['enableToolbar']">
          <i class="fa fa-chain-broken" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('image')) {
        <button type="button" class="ngx-editor-button" (click)="buildImageForm()" title="Insert Image"
          [popover]="insertImageTemplate" #imagePopover="bs-popover" containerClass="ngxePopover" [disabled]="!config['enableToolbar']">
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </button>
      }
      @if (canEnableToolbarOptions('video')) {
        <button type="button" class="ngx-editor-button" (click)="buildVideoForm()" title="Insert Video"
          [popover]="insertVideoTemplate" #videoPopover="bs-popover" containerClass="ngxePopover" [disabled]="!config['enableToolbar']">
          <i class="fa fa-youtube-play" aria-hidden="true"></i>
        </button>
      }
    </div>
  </div>
}

<!-- URL Popover template -->
<ng-template #insertLinkTemplate>
  <div class="ngxe-popover extra-gt">
    <form [formGroup]="urlForm" (ngSubmit)="urlForm.valid && insertLink()" autocomplete="off">
      <div class="form-group">
        <label for="urlInput" class="small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.URL' | translate}}</label>
        <input type="text" class="form-control-sm" id="URLInput" placeholder="{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.PLACEHOLDER.URL' | translate}}" formControlName="urlLink" required>
      </div>
      <div class="form-group">
        <label for="urlTextInput" class="small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.TEXT' | translate}}</label>
        <input type="text" class="form-control-sm" id="urlTextInput" placeholder="{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.PLACEHOLDER.TEXT' | translate}}" formControlName="urlText" required>
      </div>
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="urlNewTab" formControlName="urlNewTab">
        <label class="form-check-label" for="urlNewTab">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.OPEN-IN-NEW-TAB' | translate}}</label>
      </div>
      <button type="submit" class="btn-primary btn-sm btn">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.BUTTON.SUBMIT' | translate}}</button>
    </form>
  </div>
</ng-template>

<!-- Image Uploader Popover template -->
<ng-template #insertImageTemplate>
  <div class="ngxe-popover imgc-ctnr">
    <div class="imgc-topbar btn-ctnr">
      <button type="button" class="btn" [ngClass]="{active: isImageUploader}" (click)="isImageUploader = true">
        <i class="fa fa-upload"></i>
      </button>
      <button type="button" class="btn" [ngClass]="{active: !isImageUploader}" (click)="isImageUploader = false">
        <i class="fa fa-link"></i>
      </button>
    </div>
    <div class="imgc-ctnt is-image">
      @if (isImageUploader) {
        <div> </div>
      } @else {
        <form class="extra-gt" [formGroup]="imageForm" (ngSubmit)="imageForm.valid && insertImage()" autocomplete="off">
          <div class="form-group">
            <label for="imageURLInput" class="small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.URL' | translate}}</label>
            <input type="text" class="form-control-sm" id="imageURLInput" placeholder="{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.PLACEHOLDER.URL' | translate}}" formControlName="imageUrl" required>
          </div>
          <button type="submit" class="btn-primary btn-sm btn">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.BUTTON.SUBMIT' | translate}}</button>
        </form>
      }
      @if (!isImageUploader) {
        <div> </div>
      } @else {
        <div class="ngx-insert-img-ph">
          @if (uploadComplete) {
            <p>{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.CHOOSE-IMAGE' | translate}}</p>
          }
          @if (!uploadComplete) {
            <p>
              <span>{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.UPLOADING-IMAGE' | translate}}</span>
              <br>
                <span>{{ updloadPercentage }} %</span>
              </p>
            }
            <div class="ngxe-img-upl-frm">
              <input type="file" #fileInput (change)="onFileChange(fileInput.files)" accept="image/*" [disabled]="isUploading" [style.cursor]="isUploading ? 'not-allowed': 'allowed'">
            </div>
          </div>
        }
        @if (!uploadComplete) {
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" [ngClass]="{'bg-danger': updloadPercentage<20, 'bg-warning': updloadPercentage<50, 'bg-success': updloadPercentage>=100}"
            [style.width.%]="updloadPercentage"></div>
          </div>
        }
      </div>
    </div>
  </ng-template>


  <!-- Insert Video Popover template -->
  <ng-template #insertVideoTemplate>
    <div class="ngxe-popover imgc-ctnr">
      <div class="imgc-topbar btn-ctnr">
        <button type="button" class="btn active">
          <i class="fa fa-link"></i>
        </button>
      </div>
      <div class="imgc-ctnt is-image">
        <form class="extra-gt" [formGroup]="videoForm" (ngSubmit)="videoForm.valid && insertVideo()" autocomplete="off">
          <div class="form-group">
            <label for="videoURLInput" class="small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.URL' | translate}}</label>
            <input type="text" class="form-control-sm" id="videoURLInput" placeholder="{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.PLACEHOLDER.URL' | translate}}" formControlName="videoUrl" required>
          </div>
          <div class="row form-group">
            <div class="col">
              <input type="text" class="form-control-sm" formControlName="height" placeholder="height (px)" (keypress)="onlyNumbers($event)">
            </div>
            <div class="col">
              <input type="text" class="form-control-sm" formControlName="width" placeholder="width (px)" (keypress)="onlyNumbers($event)">
            </div>
            <label class="col-auto small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.HEIGHT-WIDTH' | translate}}</label>
          </div>
          <button type="submit" class="btn-primary btn-sm btn">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.BUTTON.SUBMIT' | translate}}</button>
        </form>
      </div>
    </div>
  </ng-template>

  <!-- Insert color template -->
  <ng-template #insertColorTemplate>
    <div class="ngxe-popover imgc-ctnr">
      <div class="imgc-topbar two-tabs">
        <span (click)="selectedColorTab ='textColor'" [ngClass]="{active: selectedColorTab ==='textColor'}">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.TEXT' | translate}}</span>
        <span (click)="selectedColorTab ='backgroundColor'" [ngClass]="{active: selectedColorTab ==='backgroundColor'}">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.BACKGROUND' | translate}}</span>
      </div>
      <div class="imgc-ctnt is-color extra-gt1">
        <form autocomplete="off">
          <div class="form-group">
            <label for="hexInput" class="small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.HEX-COLOR' | translate}}</label>
            <input type="text" class="form-control-sm" id="hexInput" name="hexInput" maxlength="7" placeholder="{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.PLACEHOLDER.HEX-COLOR' | translate}}" [(ngModel)]="hexColor"
              required>
            </div>
            <button type="button" class="btn-primary btn-sm btn" (click)="insertColor(hexColor, selectedColorTab)">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.BUTTON.SUBMIT' | translate}}</button>
          </form>
        </div>
      </div>
    </ng-template>

    <!-- font size template -->
    <ng-template #fontSizeTemplate>
      <div class="ngxe-popover extra-gt1">
        <form autocomplete="off">
          <div class="form-group">
            <label for="fontSize" class="small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.FONT-SIZE' | translate}}</label>
            <input type="text" class="form-control-sm" id="fontSize" name="fontSize" placeholder="{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.PLACEHOLDER.FONT-SIZE.PX-REM' | translate}}" [(ngModel)]="fontSize"
              required>
            </div>
            <button type="button" class="btn-primary btn-sm btn" (click)="setFontSize(fontSize)">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.BUTTON.SUBMIT' | translate}}</button>
          </form>
        </div>
      </ng-template>

      <!-- font family/name template -->
      <ng-template #fontNameTemplate>
        <div class="ngxe-popover extra-gt1">
          <form autocomplete="off">
            <div class="form-group">
              <label for="fontSize" class="small">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.LABEL.FONT-SIZE' | translate}}</label>
              <input type="text" class="form-control-sm" id="fontSize" name="fontName" placeholder="{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.PLACEHOLDER.FONT-SIZE.TIMES-NEW-ROMAN' | translate}}"
                [(ngModel)]="fontName" required>
              </div>
              <button type="button" class="btn-primary btn-sm btn" (click)="setFontName(fontName)">{{'COMPONENTS.COMMON.NGX-EDITOR.TOOLBAR.BUTTON.SUBMIT' | translate}}</button>
            </form>
          </div>
        </ng-template>
